<template>
  <main>
    <section class="file-container my-10">
      <h3 class="upload-title">
        <slot></slot>
      </h3>

      <div
        @click="onFileClick"
        class="upload-box"
        :class="{ 'disabled-box': disabled }"
      >
        <v-icon :color="disabled ? '#ccc' : '#0b7477'">mdi-upload</v-icon>
        <p
          class="upload-text"
          :style="{ color: disabled ? '#ccc' : '#0b7477' }"
        >
          {{ $t("PLACEHOLDERS.choose_file") }}
        </p>
      </div>

      <div class="file-preview-wrapper" v-if="filePreviews.length">
        <div
          class="file-preview"
          v-for="(file, index) in filePreviews"
          :key="index"
        >
          <span class="file-name" @click="openFile(file)">
            {{ getFileName(file) }}
          </span>
          <div class="file-actions">
            <v-icon small class="view-icon" @click.stop="openFile(file)">
              mdi-eye
            </v-icon>
            <span
              v-if="!disabled"
              class="remove-file"
              @click.stop="removeFile(index)"
              >×</span
            >
          </div>
        </div>
      </div>
    </section>

    <input
      type="file"
      hidden
      ref="file_input"
      :multiple="multiple"
      :accept="accept"
      @change="onFileSelect"
      :disabled="disabled"
    />
  </main>
</template>

<script>
export default {
  name: "FileUploader",
  props: {
    accept: {
      type: String,
      default: "*/*",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    urls: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      files: [],
    };
  },
  computed: {
    filePreviews() {
      return [...this.urls, ...this.files];
    },
  },
  methods: {
    getFileName(file) {
      if (typeof file === "string") {
        return file.split("/").pop() || file;
      }
      return file.name;
    },
    canViewFile(file) {
      if (typeof file === "string") return true;
      const type = file.type || "";
      return (
        type.startsWith("image/") ||
        type.startsWith("application/pdf") ||
        type.startsWith("video/") ||
        type.startsWith("text/")
      );
    },
    openFile(file) {
      if (typeof file === "string") {
        window.open(file, "_blank");
      } else {
        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, "_blank");
        setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      }
    },
    onFileClick() {
      if (this.disabled) return;
      this.$refs.file_input.value = "";
      this.$refs.file_input.click();
    },
    onFileSelect(event) {
      const selectedFiles = Array.from(event.target.files);

      if (this.multiple) {
        this.files = [...this.files, ...selectedFiles];
      } else {
        this.files = selectedFiles.slice(0, 1);
      }

      this.$emit("onFileSelect", this.files);
    },
    removeFile(index) {
      const totalOld = this.urls.length;

      if (index < totalOld) {
        this.$emit("onFileRemove", index);
      } else {
        const newFileIndex = index - totalOld;
        this.files.splice(newFileIndex, 1);
        this.$emit("onFileSelect", this.files);
      }
    },
  },
};
</script>

<style scoped>
.upload-title {
  font-family: cairo;
  font-weight: 500;
  cursor: pointer;
  color: #000;
  margin-bottom: 10px;
}

.upload-box {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #0b7477;
  padding: 20px;
  width: 400px;
  margin: auto;
  border-radius: 8px;
  gap: 10px;
  transition: all 0.3s ease;
}

.upload-box:hover:not(.disabled-box) {
  background: #f7fafa;
}

.disabled-box {
  border-color: #ccc;
  cursor: not-allowed;
}

.upload-text {
  font-size: 14px;
  color: #0b7477;
  font-weight: 900;
  margin: 0;
}

.file-preview-wrapper {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.file-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
}

.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80%;
  cursor: pointer;
  transition: color 0.2s;
}

.file-name:hover {
  color: #0b7477;
}

.file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.view-icon {
  color: #0b7477;
  cursor: pointer;
}

.view-icon:hover {
  opacity: 0.8;
}

.remove-file {
  color: #ff4444;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 0 2px;
}

.remove-file:hover {
  color: #cc0000;
}

@media (max-width: 600px) {
  .upload-box {
    width: 100%;
    padding: 15px;
  }

  .file-preview-wrapper {
    max-width: 100%;
  }
}
</style>
